import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import candidatesData from "@/data/candidates.json";
// import candidatesData from '../../data/candidates.json';
import ColumnSearch from "@/components/Common/ColumnSearch";
// import ColumnSearch from '../Common/ColumnSearch';
import candidateService from "@/services/candidateService";
import Pagination from "@/components/Common/Pagination";
import Dropdown from "@/components/ui/Dropdown";
import { Building, Building2, Search } from "lucide-react";
import { companiesService } from "@/services/companiesService";
import { campaignsService } from "@/services/campaignsService";
import { vacancyService } from "@/services/vacancyService";
import { useVacancyByCampaignId } from "@/hooks/queries/usevacancy";
import ApplicationFilters from "@/components/Companies/ApplicationFilters";
import { Settings } from "lucide-react";
import HistoryDialog from "@/components/candidates/HostoryDialog";
import CandidateTable from "@/components/candidates/candidateTable";
import { useDebounce } from "@/utils/helpers";
import { PER_PAGE } from "@/config";
import { universityService } from "@/services/unversity";
import usePaginationStore from "@/hooks/stores/usePaginationStore";
const Candidates = () => {
  const [candidates, setCandidates] = useState([]);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [selectedCompany, setSelectedCompany] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedVacancy, setSelectedVacancy] = useState(null);
  const [vacancies, setVacancies] = useState([]);
  const [loadingVacancies, setLoadingVacancies] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [majorFilters, setMajorFilters] = useState({});
  const [showColumnToggle, setShowColumnToggle] = useState(false);
  const columnToggleRef = React.useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(PER_PAGE);
  const { getPerPage, setPerPage } = usePaginationStore();
  const [serverPagination, setServerPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    per_page: getPerPage("candidates-table"),
  });
  const [personalFields, setPersonalFields] = useState([]);
  const [personalFieldsError, setPersonalFieldsError] = useState(null);
  const [universities, setUniversities] = useState([]);
  const [filters, setFilters] = useState(() => {
    const saved = localStorage.getItem("candidate_filters");
    return saved ? JSON.parse(saved) : {};
  });
  const [activeFilters, setActiveFilters] = useState(() => {
    const saved = localStorage.getItem("candidate_activeFilters");
    return saved ? JSON.parse(saved) : [];
  });

  //sorting the data
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredCandidates].sort((a, b) => {
      //console.log("key", key);
      // if (key === 'last_applied_date') {
      //   //console.log(key);
      //   const dateA = new Date(a[key]).getTime();
      //   const dateB = new Date(b[key]).getTime();
      //   return direction === 'ascending' ? dateA - dateB : dateB - dateA;
      // }
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });

    setFilteredCandidates(sortedData);
  };

  // Initial comapny fetch
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setIsLoading(true);
        // Use the companiesService to fetch companies
        const response = await companiesService.getAllCompanies();
        // console.log('Companies response:', response); // For debugging
        const companiesData = Array.isArray(response)
          ? response
          : response?.data || [];
        setCompanies(companiesData);
        setFilteredCompanies(companiesData);
      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  // function to handle search term input
  const updateSearchTerm = (term) => {
    setSearchQuery(term);
    setServerPagination((prev) => ({ ...prev, current_page: 1 }));
  };

  // defined useDebounce for search term input
  const debouncedSearch = useDebounce(updateSearchTerm, 1000);

  const [tempSearchTerm, setTempSearchTerm] = useState("");
  const handleSearchChange = (term) => {
    setTempSearchTerm(term);
    debouncedSearch(term);
  };

  // FETCH CANDIDATES (now with page & pagination)
  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        setIsLoading(true);
        // include the current page in your request
        const res = await candidateService.getCandidateListing({
          ...majorFilters,
          campaign_id: selectedCampaign,
          vacancy_id: selectedVacancy,
          page: serverPagination.current_page,
          per_page: serverPagination.per_page,
          search: searchQuery,
          ...filters,
        });
        // new API returns { data: [...], paginations: { current_page, last_page, per_page, total, … } }
        const { data, paginations } = res;
        setCandidates(data);
        setFilteredCandidates(data);
        setServerPagination({
          current_page: paginations.current_page,
          last_page: paginations.last_page,
          per_page: paginations.per_page,
          total: paginations.total,
        });
      } catch (error) {
        console.error("Error fetching candidates:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCandidates();
  }, [
    majorFilters,
    selectedCampaign,
    selectedVacancy,
    serverPagination.current_page,
    serverPagination.per_page,
    searchQuery,
    filters,
  ]);

  // SYNC any direct changes to candidates.pagination into your local pagination state
  useEffect(() => {
    if (candidates?.pagination) {
      setServerPagination(candidates.pagination);
    }
  }, [candidates]);

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        setIsLoading(true);
        if (!selectedCompany) {
          setCampaigns([]); // Clear campaigns if no company is selected
          setSelectedCampaign(""); // Reset selected campaign
          return;
        }

        const response =
          await campaignsService.getCampaignByCompanyId(selectedCompany);
        const campaignsData = Array.isArray(response)
          ? response
          : response?.data || [];
        setCampaigns(campaignsData);

        // Log the fetched campaigns to the console
        console.log("Fetched Campaigns:", campaignsData);
      } catch (error) {
        console.error("Error fetching campaigns:", error);
        setCampaigns([]);
      } finally {
        setIsLoading(false);
      }
    };
    // Update the major filters to include the selected company ID
    // This ensures that the filtering of candidates is based on the currently selected company
    setMajorFilters((previous) => ({
      ...previous,
      company_id: selectedCompany,
    }));
    //fetchCandidates();
    fetchCampaigns();
  }, [selectedCompany]); // Only run when selectedCompany changes

  // Add this useEffect to filter candidates when company or campaign selection changes
  //

  // Pagination
  const [currentPage, setCurrentPage] = useState(() => {
    const saved = localStorage.getItem("candidate_currentPage");
    return saved ? parseInt(saved) : 1;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCandidates = filteredCandidates.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredCandidates.length / itemsPerPage);
  const currentCompanies = filteredCompanies.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  // console.log("here...", currentCandidates, filteredCandidates);

  // Modify the company dropdown onChange handler
  const handleCompanyChange = async (selected) => {
    setSelectedCompany(selected?.value || "");
    setSelectedCampaign(""); // Reset campaign selection when company changes
    setSelectedVacancy(null); // Reset selected vacancy when company changes

    // Call getCandidateListing API when a company is selected
    setLoading(true);
    setError(null);
    try {
      const candidateList = await candidateService.getCandidateListing({
        per_page: serverPagination.per_page,
        page: 1,
      });
      setCandidates(candidateList);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch vacancies based on selected campaign
  useEffect(() => {
    const fetchVacancies = async () => {
      if (!selectedCampaign) {
        setVacancies([]); // Clear vacancies if no campaign is selected
        return;
      }

      setLoadingVacancies(true); // Set loading state
      try {
        const response =
          await vacancyService.getVacancyByCampaignId(selectedCampaign); // Fetch vacancies by campaign ID
        setVacancies(response); // Set vacancies
        console.log("Fetched Vacancies:", response); // Log fetched vacancies
        // Check if response is in the expected format
      } catch (error) {
        console.error("Error fetching vacancies:", error);
        setVacancies([]); // Reset vacancies on error
      } finally {
        setLoadingVacancies(false); // Reset loading state
      }
    };

    fetchVacancies();
  }, [selectedCampaign]);

  // Define the handleVacancySelect function
  const handleVacancySelect = (selected) => {
    setSelectedVacancy(selected); // Update the selected vacancy state
  };

  // Define columns for the ApplicationFilters component
  const columns = [
    { key: "name", label: "Name", filterable: true, inputType: "text" },
    { key: "email", label: "Email", filterable: true, inputType: "text" },
    {
      key: "university",
      label: "University",
      filterable: true,
      inputType: "select",
      useMultiSelect: true,
      options:
        universities.length > 0
          ? typeof universities[0]?.options === "string"
            ? universities[0].options.split(",").map((uni) => uni.trim())
            : universities.map((uni) => uni.name || uni)
          : [],
    },
    {
      key: "applied_jobs",
      label: "Applied Jobs",
      filterable: false,
      inputType: "text",
    },
    {
      key: "last_applied_date",
      label: "Last Applied Date",
      filterable: true,
      inputType: "date",
    },
    {
      key: "created_at",
      label: "Created Date",
      filterable: false,
      inputType: "date",
    },
    {
      key: "updated_at",
      label: "Updated Date",
      filterable: false,
      inputType: "date",
    },
    ...(personalFields.length > 0 && 0
      ? personalFields
          ?.map((_field) => {
            if (
              ["heading", "divider", "textarea", "file", "spacer"].includes(
                _field.field_type,
              )
            ) {
              return null;
            } else {
              return {
                key: `${_field.field_name}`,
                label: _field.field_name,
                sortable: true,
                filterable: true,
                inputType: _field.field_type,
                isField: true,
                useMultiSelect: ["select", "checkbox", "radio"].includes(
                  _field.field_type,
                ),
                options: _field.options
                  ? Array.isArray(_field.options)
                    ? _field.options
                    : _field.options.split(",")
                  : [],
              };
            }
          })
          .filter(Boolean)
      : []),
  ];

  // Add useEffect to fetch personal fields
  useEffect(() => {
    const fetchPersonalFields = async () => {
      try {
        const response = await candidateService.personalFields();
        console.log("Personal Fields Response:", response);
        setPersonalFields(response?.data || []);
        setPersonalFieldsError(null);
      } catch (error) {
        console.error("Error fetching personal fields:", error);
        console.log("Personal Fields Error Details:", error.message);
        setPersonalFieldsError(error.message);
      }
    };

    fetchPersonalFields();
  }, []);

  // Assuming processedApplications is the same as filteredCandidates
  const processedApplications = filteredCandidates;

  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = localStorage.getItem("candidate_visibleColumns");
    return saved
      ? JSON.parse(saved)
      : {
          candidateName: true,
          currentStage: true,
          rating: true,
          appliedDate: true,
          appliedDateTime: true,
          priority: true,
          actions: true,
          selection: true,
          // ...(processedApplications[0]?.fields ?
          //   Object.keys(processedApplications[0].fields).reduce((acc, fieldName) => {
          //     acc[`field_${fieldName}`] = false;
          //     return acc;
          //   }, {}) : {})
          // ...(customFields?.length > 0 ?
          //   customFields.reduce((acc, field) => {
          //     if (!['heading', 'divider', 'textarea', 'file', 'spacer'].includes(field.field_type)) {
          //       acc[`field_${field.label}`] = false;
          //     }
          //     return acc;
          //   }, {}) : {})
        };
  });

  // Add this useEffect to filter candidates based on activeFilters and filters
  useEffect(() => {
    const applyFilters = async () => {
      if (candidates.length > 0) {
        let filtered = [...candidates];

        // // Check if there are any active filters to apply
        // if (activeFilters.length > 0) {
        //   // Filter the candidates based on the active filters
        //   filtered = await filtered.filter(candidate => {
        //     // Ensure that all active filters are satisfied for each candidate
        //     return activeFilters.every(filterKey => {
        //       // Get the filter value associated with the current filter key
        //       const filterValue = filters[filterKey];
        //       // If there is no filter value, skip this filter
        //       if (!filterValue || filterValue?.length === 0) return true; // Skip if no filter value

        //       // Special handling for date fields
        //       if (filterKey === 'last_applied_date' || filterKey.includes('date') || filterKey.includes('time')) {
        //         // For date fields, we need to compare the date strings
        //         const candidateDate = String(candidate[filterKey] || '');

        //         // If it's an array of values (multi-select)
        //         if (Array.isArray(filters[filterKey])) {
        //           return filters[filterKey].some(value => {
        //             // Try to parse as date if possible
        //             try {
        //               const filterDate = new Date(value);
        //               const candidateDateObj = new Date(candidateDate);

        //               // Check if both are valid dates
        //               if (!isNaN(filterDate.getTime()) && !isNaN(candidateDateObj.getTime())) {
        //                 // Compare dates (ignoring time)
        //                 return filterDate.toDateString() === candidateDateObj.toDateString();
        //               } else {
        //                 // Fall back to string comparison if not valid dates
        //                 return candidateDate.toLowerCase().includes(String(value).toLowerCase());
        //               }
        //             } catch (e) {
        //               // If date parsing fails, fall back to string comparison
        //               return candidateDate.toLowerCase().includes(String(value).toLowerCase());
        //             }
        //           });
        //         } else {
        //           // For single value
        //           try {
        //             const filterDate = new Date(filters[filterKey]);
        //             const candidateDateObj = new Date(candidateDate);

        //             // Check if both are valid dates
        //             if (!isNaN(filterDate.getTime()) && !isNaN(candidateDateObj.getTime())) {
        //               // Compare dates (ignoring time)
        //               return filterDate.toDateString() === candidateDateObj.toDateString();
        //             } else {
        //               // Fall back to string comparison if not valid dates
        //               return candidateDate.toLowerCase().includes(String(filters[filterKey]).toLowerCase());
        //             }
        //           } catch (e) {
        //             // If date parsing fails, fall back to string comparison
        //             return candidateDate.toLowerCase().includes(String(filters[filterKey]).toLowerCase());
        //           }
        //         }
        //       }

        //       // Check if the filter value is an array (for multiple values)
        //       return Array.isArray(filters[filterKey])
        //         // If it's an array, check if any of the values match the candidate's property
        //         ? filters[filterKey].some(value => String(candidate[filterKey]).toLowerCase().includes(String(value).toLowerCase()))
        //         // If it's a single value, check if it matches the candidate's property
        //         : String(candidate[filterKey]).toLowerCase().includes(String(filters[filterKey]).toLowerCase());
        //     });
        //   });
        // }

        // Always set filteredCandidates, even when no filters are active
        setFilteredCandidates(filtered);
      }
    };
    applyFilters();
  }, [filters, activeFilters, candidates]); // Ensure this runs when filters or activeFilters change

  useEffect(() => {
    setServerPagination((prev) => ({ ...prev, current_page: 1 }));
  }, [filters]);

  // Add a function to remove a filter
  const removeFilter = (filterKey) => {
    const newActiveFilters = activeFilters.filter((key) => key !== filterKey);
    setActiveFilters(newActiveFilters);

    setFilters((prev) => {
      const newFilters = { ...prev };
      delete newFilters[filterKey];
      return newFilters;
    });
  };

  // Pagination changes
  const handlePageChange = (page) => {
    setServerPagination((prev) => ({
      ...prev,
      current_page: page,
    }));
  };

  // Handle pagination dropdown change
  const handlePaginationChange = (selectedOption) => {
    const newPerPage = selectedOption.value;
    setPerPage("candidates-table", newPerPage);
    setServerPagination((prev) => ({
      ...prev,
      per_page: newPerPage,
      current_page: 1, // Reset to first page when changing items per page
    }));
  };
  // Add this useEffect to filter candidates based on search query
  useEffect(() => {
    if (candidates.length > 0) {
      let filtered = [...candidates];
      // Filter based on search query
      if (searchQuery) {
        filtered = filtered.filter((candidate) => {
          // Check if the search query matches any of the candidate's properties
          const searchLower = searchQuery.toLowerCase();

          // Check name and email as before
          if (
            candidate.name.toLowerCase().includes(searchLower) ||
            candidate.email.toLowerCase().includes(searchLower)
          ) {
            return true;
          }

          // Check date fields
          const dateFields = ["last_applied_date", "created_at", "updated_at"];
          for (const field of dateFields) {
            if (candidate[field]) {
              const dateStr = String(candidate[field]);

              // Try to parse as date
              try {
                const date = new Date(dateStr);
                if (!isNaN(date.getTime())) {
                  // Format the date in various ways to check for matches
                  const dateFormats = [
                    date.toLocaleDateString(),
                    date.toLocaleTimeString(),
                    date.toLocaleString(),
                    date.toISOString().split("T")[0], // YYYY-MM-DD
                    date.toISOString().split("T")[1].split(".")[0], // HH:MM:SS
                    date.toISOString(), // Full ISO string
                  ];

                  // Check if any of the date formats include the search query
                  if (
                    dateFormats.some((format) =>
                      format.toLowerCase().includes(searchLower),
                    )
                  ) {
                    return true;
                  }
                }
              } catch (e) {
                // If date parsing fails, fall back to string comparison
                if (dateStr.toLowerCase().includes(searchLower)) {
                  return true;
                }
              }
            }
          }

          // Check other fields
          for (const key in candidate) {
            if (
              typeof candidate[key] === "string" &&
              candidate[key].toLowerCase().includes(searchLower)
            ) {
              return true;
            }
          }

          return false;
        });
      }
      // ... existing filtering logic ...
      setFilteredCandidates(filtered);
    }
  }, [filters, activeFilters, candidates, searchQuery]); // Add searchQuery to dependencies

  // For some wierd reason, the ids are coming as strings, so we need to convert them to numbers
  const handleCandidatesDelete = async (ids) => {
    console.log("Candidate deleted:", ids);
    setCandidates(
      candidates.filter((candidate) => !ids.includes(String(candidate.id))),
    );
    setFilteredCandidates(
      filteredCandidates.filter(
        (candidate) => !ids.includes(String(candidate.id)),
      ),
    );

    // Refetch the candidate data
    try {
      setIsLoading(true);
      const response = await candidateService.getCandidateListing({
        ...majorFilters,
        campaign_id: selectedCampaign,
        vacancy_id: selectedVacancy,
        page: serverPagination.current_page,
        per_page: serverPagination.per_page,
      });
      setCandidates(response?.data);
      setFilteredCandidates(response?.data);
    } catch (error) {
      console.error("Error refetching candidates:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [filterInputs, setFilterInputs] = useState(null);

  // Add useEffect to fetch universities
  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        const response = await universityService.fetchUniversities();
        // Handle both array and object response formats
        const universityData = Array.isArray(response)
          ? response
          : response?.data || [];
        setUniversities(universityData);
      } catch (error) {
        console.error("Error fetching universities:", error);
      }
    };

    fetchUniversities();
  }, []);

  return (
    <div className="w-[90%] mx-auto pt-12 pb-24 px-8 flex flex-col gap-8">
      {/* Search Bar */}

      {/* Modal for viewing candidate details */}
      <HistoryDialog
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        candidate={selectedCandidate}
      />
      <div className="">
        <div
          data-actions="false"
          data-breadcrumbs="false"
          data-divider="false"
          data-search="false"
          data-style="Simple"
          data-supporting-text="true"
          className="self-stretch flex flex-col justify-start items-start gap-4"
        >
          <div className="self-stretch inline-flex justify-start items-start gap-4 flex-wrap content-start">
            <div className="flex-1 min-w-80 inline-flex flex-col justify-start items-start gap-1">
              <div className="self-stretch justify-start text-foreground text-2xl font-semibold font-['Inter'] leading-8">
                Candidates
              </div>
              <div className="self-stretch justify-start text-muted-foreground text-base font-normal font-['Inter'] leading-6">
                Review candidate profiles, manage application progress, and keep
                notes and updates in one place.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="inline-flex gap-2">
          <div className="hidden">
            <Dropdown
              options={filteredCompanies.map(company => ({
                label: company.name,
                value: company.id
              }))}
              value={selectedCompany ? { label: filteredCompanies.find(c => c.id === selectedCompany)?.name, value: selectedCompany } : null}
              onChange={handleCompanyChange}
              placeholder="Select Company"
              icon={<Building className="w-5 h-5 text-foreground flex-shrink-0" />}
              searchable={true}
              // className="w-64"
              dropdownWidth="max-w-64"
            />
          </div>

          <div className="hidden ">
            <Dropdown
              options={campaigns
                .map(campaign => ({
                  label: campaign.title,
                  value: campaign.id
                }))
                .sort((a, b) => a.label.localeCompare(b.label))}
              value={selectedCampaign ? { label: campaigns.find(c => c.id === selectedCampaign)?.title, value: selectedCampaign } : null}
              onChange={(selected) => setSelectedCampaign(selected?.value || '')}
              placeholder="Select Campaign"
              icon={<Building2 className="w-5 h-5 text-foreground flex-shrink-0" />}
              searchable={true}
              // className="w-64"
              dropdownWidth="max-w-64"
              isDisabled={!selectedCompany} // Disable if no company is selected
            />

          </div>
          <div className="hidden ">
            <Dropdown
              options={vacancies?.vacancies?.map(vacancy => ({
                label: vacancy.title,
                value: vacancy
              })) || []}
              value={selectedVacancy ? { label: selectedVacancy.title, value: selectedVacancy } : null}
              onChange={(selected) => handleVacancySelect(selected.value)}
              placeholder="Select Vacancy"
              icon={<Building2 className="w-5 h-5 text-foreground flex-shrink-0" />}
              searchable={true}
              // className="w-64"
              dropdownWidth="max-w-64"
              renderOption={(option) => (
                <p className="text-foreground">
                  {option.label}
                </p>
              )}
            />
          </div>
       
      </div> */}
      <div>
        <div className="flex mb-3 justify-between items-center">
          <div className="w-full max-w-[384px]">
            <div className="self-stretch h-11 px-3.5 py-2.5 bg-background rounded-lg border border-input inline-flex justify-start items-center gap-2 overflow-hidden">
              <Search className="w-5 h-5 text-muted-foreground" />
              <input
                id="search"
                type="text"
                placeholder="Search"
                value={tempSearchTerm}
                onChange={(e) => handleSearchChange(e.target.value)}
                className="flex-1 text-foreground placeholder:text-muted-foreground text-base font-normal leading-6 outline-none bg-transparent"
              />
            </div>
          </div>

          <div>
            <ApplicationFilters
              columns={columns}
              //visibleColumns={{ name: true, email: true, applied_jobs: true, last_applied_date: true }}
              visibleColumns={columns
                .filter((column) => column.filterable)
                .reduce((acc, column) => {
                  acc[column.key] = true;
                  return acc;
                }, {})}
              processedApplications={[]}
              onFiltersChange={(filters, activeFilters) => {
                setFilters(filters);
                setActiveFilters(activeFilters);
              }}
              filtersStorageKey="candidate_filters"
              activeFiltersStorageKey="candidate_activeFilters"
              filterInputTriggerClasses="bg-card"
              // getFiltersComponent={(_filterInputs) =>
              //   setFilterInputs(_filterInputs)
              // }
            />
          </div>
        </div>
        <div className="block">
          {filterInputs && filterInputs != null && (
            <div className="flex flex-wrap justify-end my-3 gap-2 w-full">
              {filterInputs}
            </div>
          )}
        </div>
      </div>

      {/* Candidate List (Cards) */}
      <div className="overflow-x-auto">
        <CandidateTable
          filteredCandidates={filteredCandidates}
          isLoading={isLoading}
          handleSort={handleSort}
          sortConfig={sortConfig}
          setSelectedCandidate={setSelectedCandidate}
          setIsModalOpen={setIsModalOpen}
          onCandidatesDelete={handleCandidatesDelete}
          serverPagination={serverPagination}
          onPageChange={handlePageChange}
          onPerPageChange={handlePaginationChange}
        />
      </div>
    </div>
  );
};

export default Candidates;
